export default "__VITE_ASSET__DHnvJlfx__"